import com.github.chosamuel.kishibe.application.*
import com.github.chosamuel.kishibe.application.renderer.clear
import com.github.chosamuel.kishibe.application.renderer.fill
import com.github.chosamuel.kishibe.math.map
import com.github.chosamuel.kishibe.noise.simplex
import com.github.chosamuel.kishibe.webgl.createShader
import com.github.chosamuel.matterjs.collision.Pair
import com.github.chosamuel.matterjs.collision.Pairs
import com.github.chosamuel.matterjs.core.Matter
import com.github.chosamuel.matterjs.geometry.Vector
import com.github.chosamuel.matterjs.jsObject
import org.w3c.dom.events.Event
import kotlin.random.Random

fun main() {
}

val app = Application {
    Program {
        //CREATE MATTER ENGINE
        val en = Matter.Engine.create(jsObject{
            gravity = jsObject {
                x = 0
                y = 3.0
            }
            enableSleeping = true
            positionIterations = 4
        })
        val runner = Matter.Runner.create()
        Matter.Runner.run(runner,en) //starts the engine

        //WIND CHIME BEAM
        val beam = createBeam()
        Matter.Composite.add(en.world,beam.body)

        val connection = createBeamConstraint(beam.body)
        Matter.Composite.add(en.world,connection)
        //COLOR MODE
        var mode = 0.0
        var targetmode = 0.0

        //CHIMES
        val numChimes = Random.nextInt(6,8)
        val chimeWidth = map(6*1.0,
            8*1.0,
            getWidth()*0.075,
            getWidth()*0.05,
            numChimes.toDouble()
        )
        val chimes = createChimes(beam,numChimes,chimeWidth)
        chimes.forEach{ Matter.Composite.add(en.world,it.body) }

        val chimeConnections = createChimeConnections(beam.body,chimes)
        chimeConnections.forEach{
            Matter.Composite.add(en.world,it)
        }
        useMouseConstraint(en)
        val chimeRanks = rankArray(chimes)

        //SHADER
        val defaultShader = createShader(defaultVs,fs)
        val shader = createShader(vs,fs)

       //SYNTH
        val reverb = Tone.Reverb(jsObject{
            decay = 20.0
            wet = 1.0
        }).toDestination()
        val filter = Tone.Filter(300.0,"lowpass").connect(reverb)
         val poly = js("""new Tone.PolySynth(Tone.Synth, {
             oscillator: {
                type : "sawtooth"
             }
             })""") as Tone.PolySynth
        poly.set(jsObject{
            envelope = jsObject{
                decay = 5.0
                sustain = 0.0
                release = 0.0
            }
            polyphony = 8
        })
        poly.connect(filter)
        val notes = arrayOf("F#5","C#5","G#5","A5","E5","A6","B6","D#6")
        //EVENTS
        Matter.Events.on(en,"collisionStart",fun(e: dynamic){
            js("var p = []")
            js("e.pairs.forEach(function(collision){p.push(collision)})")
            val pairs = js("p") as Array<Pair>
            val ids = pairsToInts(pairs)
            ids.forEach {
                val i = it - 3
                if(i >= 0){
                    val pitch = notes[notes.size-(chimeRanks[i])]
                    poly.triggerRelease(pitch)
                    poly.triggerAttackRelease(pitch,5)
                }
                targetmode = Random.nextDouble(4.0)
            }
        })
        onClick = { Tone.start() }

        Draw {
            clear(0.0)
            fill(1.0)
            defaultShader.use()
            defaultShader.setUniform1f("time",frameCount.toFloat())
            mRect(beam)

            mode += (targetmode - mode) * 0.05
            shader.use()
            shader.setUniform1f("numChimes",12f)
            shader.setUniform1f("time",frameCount.toFloat())
            shader.setUniform1f("mode",mode.toFloat())
            chimes.forEachIndexed { i,it->
                shader.setUniform1f("chimeID",i.toFloat())
                mRect(it)
                if(frameCount % (60*5) == 0) {
                    val forceSize = simplex(i * 0.01, 0.0, frameCount * 0.005)
                        .let { it * 0.1 }
                    Matter.Body.applyForce(
                        it.body,
                        Matter.Vector.create(it.center.x,it.center.y+(it.height*0.5)),
                        Matter.Vector.create(forceSize, 0.0)
                    )
                }
            }
        }
    }
}
